import type { MaterialIntent, ProjectSpace } from "@contractor-quoting/shared-types";
import { materialIntentSchema, projectSpaceSchema } from "@contractor-quoting/shared-types";

export interface PendingProjectFormDraft {
  spaces: ProjectSpace[];
  materialIntent: MaterialIntent;
}

const keyPrefix = "mezoniq-project-form-draft:";
const keyFor = (projectId: string) => `${keyPrefix}${projectId}`;

export function loadPendingProjectFormDraft(projectId: string): PendingProjectFormDraft | null {
  try {
    const value = localStorage.getItem(keyFor(projectId));
    if (!value) return null;
    const candidate = JSON.parse(value) as { spaces?: unknown; materialIntent?: unknown };
    const spaces = projectSpaceSchema.array().safeParse(candidate.spaces);
    const materialIntent = materialIntentSchema.safeParse(candidate.materialIntent);
    if (!spaces.success || spaces.data.length === 0 || !materialIntent.success) return null;
    return { spaces: spaces.data, materialIntent: materialIntent.data };
  } catch {
    return null;
  }
}

export function savePendingProjectFormDraft(
  projectId: string,
  draft: PendingProjectFormDraft,
): void {
  try {
    localStorage.setItem(keyFor(projectId), JSON.stringify(draft));
  } catch {
    // The server autosave remains available when local storage is unavailable.
  }
}

export function clearPendingProjectFormDraft(projectId: string): void {
  try {
    localStorage.removeItem(keyFor(projectId));
  } catch {
    // A completed server autosave does not depend on local storage cleanup.
  }
}
